'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');
// const gsap = require('gsap').default;
// const Events = require('constants/Events');

require('./Base.less');

// const Selectors = {
// };

const BindFunctions = [
    '_attachEvents',
    'onShow',
    'onActive',
    'canVideoBeAutoPlayed',
    'videoIsReady'
];

module.exports = Base.extend({

    events: {
        'mouseenter .IndexFeatures-Base-hoverArea': 'onMouseEnter',
        'mouseleave .IndexFeatures-Base-hoverArea': 'onMouseLeave'
    },

    initialize: function () {
        Base.prototype.initialize.call(this);
        _.bindAll(this, BindFunctions);

        this.$content = this.$('.IndexFeatures-Base-content');
        this.path = this.$content.attr('data-path');

        this._attachEvents();

        this.canVideoBeAutoPlayed(app.settings.hasAutoPlay);

        if (app.settings.isTablet) {
            this.$el.addClass('hovered');
        }
    },

    _attachEvents: function () {

    },

    canVideoBeAutoPlayed: function (hasAutoPlay) {
        let fallbackName = 'fallback.png';

        if (app.settings.isWebp) {
            fallbackName = 'fallback.webp';
        }

        if (app.settings.isIE || !hasAutoPlay) {
            $('<img>')
                .addClass('IndexFeatures-Base-content-fallback')
                .attr('src', this.path + fallbackName)
                .appendTo(this.$content);
        } else {
            this.videosToWait = app.settings.isDesktop ? 3 : 1;
            this.videoShow = this.createVideo('show');

            if (app.settings.isDesktop) {
                this.videoHover = this.createVideo('hover');
                this.videoUnhover = this.createVideo('unhover');
            }

            $('<img>')
                .addClass('IndexFeatures-Base-content-overlay')
                .attr('src', this.path + 'overlay.png')
                .appendTo(this.$content);
        }
    },

    createVideo: function (tp) {
        const className = `IndexFeatures-Base-content-video-${tp}`;
        const path = `${this.path}${tp}.mp4`;

        const params = {
            $container: this.$content,
            className,
            path,
            callback: this.videoIsReady
        };

        return app.utils.createVideoSequence(params);
    },

    videoIsReady: function () {
        this.videosToWait--;

        if (this.videosToWait === 0 && this.showVideosAfterReady) {
            this.play('show');
        }
    },

    onShow: function () {
        if (!app.settings.isPhone || this.playOnShowOnPhone) {
            setTimeout(this.onActive, app.settings.isPhone ? 0 : this.showDelay);
        }
    },

    onActive: function () {
        if (this.isActive) {
            return;
        }
        this.$el.addClass('shown');
        this.play('show');
        this.isActive = true;
    },


    onMouseEnter: function () {
        if (!app.settings.isDesktop) {
            return;
        }
        this.$el.addClass('hovered');
        this.videoHover && this.play('hover');
    },


    onMouseLeave: function () {
        if (!app.settings.isDesktop) {
            return;
        }
        this.$el.removeClass('hovered');
        this.videoUnhover && this.play('unhover');
    },


    play: function (tp) {
        if (this.videosToWait !== 0) {
            this.showVideosAfterReady = true;

            return;
        }

        clearTimeout(this.inTimeout);
        clearTimeout(this.outTimeout);
        clearTimeout(this.showEndTimeout);

        var isShowing = this.videoShow && (this.videoShow.currentTime < this.videoShow.duration - 0.01);

        if (tp === 'show' && this.videoShow) {
            this.isFirstHover = true;
            this.videoShow.style.opacity = 1;
            app.utils.forcePlay(this.videoShow);
        }

        if (tp === 'hover') {
            if (!isShowing) {
                if (!this.isFirstHover) {
                    app.utils.forcePause(this.videoUnhover);
                    this.videoHover.currentTime = (this.videoUnhover.duration - this.videoUnhover.currentTime) * 2;
                }
                this.isFirstHover = false;
            } else {
                this.showEndTimeout = setTimeout(function () {
                    app.utils.forcePause(this.videoShow);
                    this.play('hover');
                }.bind(this), (this.videoShow.duration - this.videoShow.currentTime) * 1000);

                return;
            }

            this.inTimeout = setTimeout(function () {
                this.videoShow.style.opacity = 0;
                this.videoUnhover.style.opacity = 0;
                this.videoHover.style.opacity = 1;
                app.utils.forcePlay(this.videoHover);
            }.bind(this), 50);
        }

        if (tp === 'unhover' && !isShowing) {
            app.utils.forcePause(this.videoHover);

            this.videoUnhover.currentTime = (this.videoHover.duration - this.videoHover.currentTime) / 2;

            this.outTimeout = setTimeout(function () {
                this.videoHover.style.opacity = 0;
                this.videoUnhover.style.opacity = 1;
                app.utils.forcePlay(this.videoUnhover);
            }.bind(this), 50);
        }
    }

});
